var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesignDevelopment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 682.66669 682.66669",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1093"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1103"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path1101",
    fill: "#734a12",
    "data-original": "#000000",
    className: ""
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g1095",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1097"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1099",
    clipPath: "url(#clipPath1103)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1105",
    transform: "translate(10,156.5269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 0,-16.71 13.54,-30.24 30.23,-30.24 H 461.76 C 478.46,-30.24 492,-16.71 492,0 V 293.06 H 0 Z",
    style: {
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1107",
    fill: "none",
    stroke: "#734a12",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1109",
    transform: "translate(471.7598,498.7769)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -431.53 c -16.69,0 -30.23,-13.53 -30.23,-30.23 v -18.96 h 492 v 18.96 C 30.24,-13.53 16.7,0 0,0 Z",
    style: {
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1111",
    fill: "none",
    stroke: "#734a12",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1113",
    transform: "translate(299.5591,13.2231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h 88.632 v 26.137 c 0,16.36 -13.262,29.622 -29.621,29.622 h -205.14 c -16.36,0 -29.621,-13.262 -29.621,-29.622 V 0 h 87.758",
    style: {
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1115",
    fill: "none",
    stroke: "#734a12",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1117",
    transform: "translate(501.9976,197.1836)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -491.996 v -40.661 c 0,-16.698 13.538,-30.235 30.237,-30.235 H -30.236 C -13.537,-70.896 0,-57.359 0,-40.661 Z",
    style: {
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1119",
    fill: "none",
    stroke: "#734a12",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1121",
    transform: "translate(256,126.2871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -64.915 V -57.305 H 0 64.915 V 0 Z",
    style: {
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1123",
    fill: "none",
    stroke: "#734a12",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1125",
    transform: "translate(53.7241,388.6123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -9.284",
    style: {
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1127",
    fill: "none",
    stroke: "#734a12",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1129",
    transform: "translate(53.7241,320.7485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -9.284",
    style: {
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1131",
    fill: "none",
    stroke: "#734a12",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1133",
    transform: "translate(467.6309,314.8213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -8.421",
    style: {
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1135",
    fill: "none",
    stroke: "#734a12",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 88.162,259.899 h -78.16 v 189.689 h 78.16 z",
    style: {
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1137",
    fill: "none",
    stroke: "#734a12",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 502,269.899 h -78.159 v 89.844 H 502 Z",
    style: {
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1139",
    fill: "none",
    stroke: "#734a12",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 502,359.743 h -78.159 v 89.845 H 502 Z",
    style: {
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1141",
    fill: "none",
    stroke: "#734a12",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1143",
    transform: "translate(467.6309,404.6655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -8.421",
    style: {
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1145",
    fill: "none",
    stroke: "#734a12",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1147",
    transform: "translate(137.8159,371.5552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -92.886 l 75.184,-32.882 v 93.614 z",
    style: {
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1149",
    fill: "none",
    stroke: "#734a12",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1151",
    transform: "translate(288.1841,371.5552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -92.886 l -75.184,-32.882 v 93.614 z",
    style: {
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1153",
    fill: "none",
    stroke: "#734a12",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1155",
    transform: "translate(213,404.437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -75.184,-32.882 0,-65.036 75.184,-32.882 Z",
    style: {
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1157",
    fill: "none",
    stroke: "#734a12",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 88.162,259.899 h -78.16 v -62.715 h 78.16 z",
    style: {
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1159",
    fill: "none",
    stroke: "#734a12",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1161",
    transform: "translate(361.0991,241.7876)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V 151.325",
    style: {
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1163",
    fill: "none",
    stroke: "#734a12",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1165",
    transform: "translate(386.3291,367.8823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -25.23,25.23 -50.46,0",
    style: {
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1167",
    fill: "none",
    stroke: "#734a12",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1169",
    transform: "translate(335.8687,267.0186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 25.23,-25.231 50.461,0",
    style: {
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1171",
    fill: "none",
    stroke: "#734a12",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1173",
    transform: "translate(256,13.2231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V 0",
    style: {
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1175",
    fill: "none",
    stroke: "#734a12",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    className: ""
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignDevelopment);
export default __webpack_public_path__ + "static/media/design_development.774a90af8c3f1d871c710ad9be0aef2f.svg";
export { ForwardRef as ReactComponent };